import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCity, faMap, faMapMarkerAlt, faTree, faShoppingBag, faUtensils,
  faTrain, faBus, faBusAlt, faTrainSubway, faSubway, faShip, faMotorcycle,
  faPalette, faNewspaper, faPlayCircle, faHome, faStar, faTaxi, faShieldAlt, faPhoneAlt, faHospital, faWater
} from '@fortawesome/free-solid-svg-icons';

import './ThinkTimeTable.css';
import thinktimetableimage from '../../assets/pageimages/ThinkTimeTable.webp';

function ThinkTimeTableHome() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-blue-200 via-blue-400 to-blue-600 flex flex-col items-center py-8">
        <h2 className="text-2xl font-bold text-white text-center mb-4">ThinkTimeTable</h2>
        <img
          src={thinktimetableimage}
          alt="ThinkTimeTable"
          style={{width:'300px', height: 'auto'}}
          className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md mb-4"
        />
        <LinkButton to="/ad-air-bubble" icon={faWater} label="Air Bubble"/>               

        <div className="flex-grow">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 p-4 bg-orange-400 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkNoButton to="" icon={faCity} label="My City" />               
            <LinkNoButton to="" icon={faMap} label="My State" />             
            <LinkNoButton to="" icon={faMapMarkerAlt} label="I am At" />  
            <LinkNoButton to="" icon={faTree} label="Picnic" />      
            <LinkNoButton to="" icon={faShoppingBag} label="Shoppings" /> 
            <LinkNoButton to="" icon={faUtensils} label="Food" />      
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 p-4 bg-lime-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkNoButton to="" icon={faTrain} label="Local Train" />               
            <LinkNoButton to="" icon={faBus} label="Municipal Buses" />             
            <LinkNoButton to="" icon={faBusAlt} label="State Transport Buses" />              
            <LinkNoButton to="" icon={faTrainSubway} label="Express Trains" />        
            <LinkNoButton to="" icon={faSubway} label="Metro Rail" />      
            <LinkNoButton to="" icon={faTrain} label="Mono Rail" />              
            <LinkNoButton to="" icon={faTaxi} label="Cab" />    
            <LinkNoButton to="" icon={faShip} label="Water Transport" />                 
            <LinkNoButton to="" icon={faMotorcycle} label="Auto Rickshaw" />              
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkNoButton to="" icon={faPalette} label="Exhibitions" />               
            <LinkNoButton to="" icon={faNewspaper} label="Classifieds" />             
            <LinkNoButton to="" icon={faPlayCircle} label="Play" />              
            <LinkNoButton to="" icon={faHome} label="Property" />        
            <LinkNoButton to="" icon={faStar} label="Popular Places" />              
            <LinkNoButton to="" icon={faMap} label="Map" />    
            <LinkNoButton to="" icon={faShieldAlt} label="Police Stations" />                 
            <LinkNoButton to="" icon={faPhoneAlt} label="Emergency Contacts" /> 
            <LinkNoButton to="" icon={faHospital} label="Health Services" /> 
            <LinkNoButton to="" icon={faWater} label="Supply Water" /> 
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkTimeTableHome;
